import { parseApiErrorMessage } from "../../../common/apiErrors"

export const INVITE_UNAVAILABLE_TITLE = "Your Invitation Has Expired"

export const INVITE_UNAVAILABLE_MESSAGE =
  "This invitation link is no longer valid. Request a new invitation to continue."

const INVITE_UNAVAILABLE_PATTERNS = [
  "expired",
  "no longer valid",
  "no longer available",
  "revoked",
]

export function isInviteUnavailableMessage(message) {
  if (!message) {
    return false
  }
  const lower = message.toLowerCase()
  return INVITE_UNAVAILABLE_PATTERNS.some((pattern) => lower.includes(pattern))
}

export function parseInviteError(data, fallback = "Invalid invitation link.") {
  const tokenMessage = parseApiErrorMessage(data, fallback)
  if (isInviteUnavailableMessage(tokenMessage)) {
    return {
      unavailable: true,
      title: INVITE_UNAVAILABLE_TITLE,
      message: INVITE_UNAVAILABLE_MESSAGE,
    }
  }
  return { unavailable: false, message: tokenMessage }
}
